import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Button} from "primeng/button";
import {TranslatePipe} from "@ngx-translate/core";
import {SipoService} from "../../services/SipoService";
import {log} from "@angular-devkit/build-angular/src/builders/ssr-dev-server";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {SignerModel} from "../../model/signer-model";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-delete-sign-confirm',
    standalone: true,
    imports: [
        Button,
        TranslatePipe,
        NgIf
    ],
    templateUrl: './delete-sign-confirm.component.html',
    styleUrl: './delete-sign-confirm.component.scss'
})
export class DeleteSignConfirmComponent {

    @Input() signerModel!: SignerModel;

    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
        this.signerModel = this.config.data.signerModel
    }



    confirmDelete() {
        this.ref.close(true);
    }
}
